export const Colors = {
  GREEN_COLOR: "#97C291",
  DARK_GREEN:"#82aab2",
  YELLOW:"#ffc107",
  RED:"#c65d2f",
  BLACK:"#000000"
};
